export default __webpack_public_path__ + "static/media/logo.1c149889.svg";